<template>
  <div style="height: 100%">
    <!-- 学历院校管理 -->
    <el-button-group>
      <el-button type="primary" size="large" @click="addFnc($event)"
      >
        <el-icon>
          <Plus/>
        </el-icon>
        添加院校
      </el-button
      >
    </el-button-group>
    <!-- 表格组件 -->
    <TableList
        componentTableId="SchoolManagement"
        @update-list="updateList"
        excelName="学历院校管理"
        :table-data="tableData"
        :header-data="headerData"
        :table-height="tableMaxHeight"
        :loading="loading"
        :loading-text="loadingText"
        :empty-text="emptyText"
        @editFnc="editFnc"
        @deleteFnc="deleteFnc"
        @searchFnc="searchFnc"
        @openContent="openContent"
    >
    <template #operationCustom="scope">
      <el-button type="primary" @click="editFnc(scope.scope)" plain>编辑</el-button>
      <!-- <el-button  type="danger" @click="deleteFnc(scope.scope)" plain v-if="roleId!=configRoleId">删除</el-button> -->
      <el-button  type="danger" @click="deleteFnc(scope.scope)" plain v-if="isDelect">删除</el-button>
    </template>
    <template #nameCustom="scope">
      <span class="hand blue" @click="openCourseDetail(scope.scope)">{{
        scope.scope.name
      }}</span>
    </template>
      <template #majorsCustom="scope">
        <span
            class="hand blue"
            v-if="scope.scope.majors && scope.scope.majors.length > 0"
            @click="openReleve(scope.scope)"
        >
          已关联{{ scope.scope.majors.length }}个专业</span
        >
        <span v-else class="hand blue" @click="openReleve(scope.scope)"
        >设置关联</span
        >
      </template>
    </TableList>
    <!-- 底部工具 -->
    <Pagination
        :pagination="pagination"
        :is-loading="loading"
        @change-pagination="changePagination"
    >
    </Pagination>
    <!-- 添加编辑 院校管理 -->
      <el-dialog
          class="dialogNoPadding"
          :before-close="handleClose"
          :close-on-click-modal="false"
          v-model="addEditVisible"
          :title="dialogTitle"
          width="800px"
          :autofocus="true"
          draggable
          destroy-on-close
      >
        <AddEditSchool
            ref="AddEditComponent"
            v-if="addEditVisible"
            :edit-id="editId"
            @close-dialog="closeDialog"
            @update-list="updateList"
        ></AddEditSchool>
      </el-dialog>
       <!-- 打开前台移动端 -->
      <el-dialog
        :close-on-click-modal="false"
        v-model="UrlOpenFlag"
        :title="selectTitle"
        width="400px"
        append-to-body="false"
        draggable
        destroy-on-close
      >
        <OpenMobile
          ref="UrlOpen"
          v-if="UrlOpenFlag"
          :url="mobileUrl"
          :studentDialogTitle="selectTitle"
        >
        </OpenMobile>
      </el-dialog>
    <!-- 院校内容 -->
    <el-dialog
        :close-on-click-modal="false"
        v-model="contentVisible"
        :title="contentdialogTitle"
        width="650px"
        draggable
        destroy-on-close
    >
      <div
          class="contentDialog"
          v-html="contentDetails"
          v-if="contentVisible"
      ></div>
    </el-dialog>
    <!-- 专业列表 -->
      <el-dialog
          class="table_dialog"
          :close-on-click-modal="false"
          v-model="notpbMajorTable"
          title="选择关联专业"
          width="850px"
          draggable
          destroy-on-close
      >
        <NotPbMajorRelevancy
            v-if="notpbMajorTable"
            :ids-array="majorIds"
            :school-id="schoolId"
            :category-id="category"
            @close-dialog="closeDialog"
            @update-list="updateList"
        ></NotPbMajorRelevancy>
      </el-dialog>
  </div>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
// import TableList from "@/components/TableList.vue";
import Pagination from "components/Pagination.vue";
import {reactive, onMounted, toRefs,computed , ref, toRaw,h} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import {lostFocus} from "common/utils";
import constGlobal from "common/global.js";
import NotPbMajorRelevancy from "components/NotPbMajorRelevancy.vue";
import AddEditSchool from "views/schoolManagement/AddEditSchool.vue";
import {getSchoolList, removeSchool} from "network/schoolManagement.js";
import OpenMobile from "components/OpenMobile"
import store from "../../store/index";

export default {
  name: "SchoolManagement",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditSchool,
    NotPbMajorRelevancy,
    OpenMobile
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
       // 登录状态
       AdminCache: computed(() => {
        return (
          store.state.AdminCache ||
          JSON.parse(sessionStorage.getItem("AdminCache"))
        );
      }),
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      isTest: true,
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      // isDelect: sessionStorage.getItem("isDelect"),
      UrlOpenFlag: false, //打开前台移动端
      mobileUrl: "", // 跳转前台移动端url
      selectTitle: "",
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        }, {
          label: "院校名称",
          prop: "name",
          minWidth: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
          custom:true,
        },
        {
          label: "院校类型",
          prop: "categroyName",
          width: "180",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "院校下专业列表",
          prop: "majors",
          align: "center",
          noSetText: "未设置",
          width: "140",
          custom: true,
          operation: true
        },
        {
          label: "院校内容",
          prop: "contents",
          width: "120",
          align: "center",
          noSetText: "未设置",
          isToMoreContents: true,
        },

        {
          label: "院校图片",
          prop: "logoPath",
          align: "center",
          noSetText: "未设置",
          width: "100",
          isImg: true,
        },
        {
          label: "排序",
          prop: "orderIndex",
          align: "center",
          width: "80",
          noSetText: "未设置",
        },
        {
          label: "联系电话",
          prop: "tel",
          align: "center",
          width: "150",
          noSetText: "未设置",
        },
        {
          label: "关键字",
          prop: "keywords",
          align: "center",
          width: "250",
          noSetText: "未设置",
          isTagArr: true,
        },
        {
          label: "院校地址",
          prop: "address",
          align: "center",
          width: "250",
          noSetText: "未设置",
        },
        {
          label: "操作",
          prop: "operation",
          width: "200",
          align: "center",
          fixed: "right",
          operation: true,
          edit: true,
          delete: true,
          custom:true,
        },
      ],
      //筛选项
      search: {
        name: null,
        category: null,
      },
      dialogTitle: "添加院校",
      addEditVisible: false, //添加编辑弹窗
      contentdialogTitle: "查看院校内容",
      contentVisible: false, //院校内容弹窗
      contentDetails: "", //院校内容
      editId: 0,
      notpbMajorTable: false, //非普本专业列表
      majorIds: [],
      schoolId: null,
      category: null
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      data.headerData.map((item) => {
        if (item.prop == "categroyName") {
          item.selectOptions = constGlobal.schoolType;
        }
      });
      getSchoolData(); //请求院校列表数据
    });
    // const isDelect=computed(function(){
    //   let isShow = store.state.isDelect || sessionStorage.getItem("isDelect")
    //   console.log(isShow,'isShow');
    //   if(isShow && isShow == 'true'){
    //     return true
    //   }else{
    //     return false
    //   }
        
    // });
    // 跳转前台对应课程详情页
    const UrlOpen = ref()
    const openCourseDetail = (item) => {
      ElMessageBox({
        title: "预览提示",
        message: h("p", null, [
          h("span", null, "查看院校 "),
          h("span", null, `[${item.name}]`),
          h("span", null, "详情，请选择打开端口 "),
        ]),
        showCancelButton: true,
        confirmButtonText: "打开电脑端",
        cancelButtonText: "打开移动端",
        customClass: "msgbox-custom",
        distinguishCancelAndClose: true, //该属性可区分用户点击的是cancel取消按钮，还是close关闭，设为false时默认均为cancel
      }).then((action) => {
        if (action === "confirm") {
            let name = ''
           if (item.categroyName=='开放教育'){
              name = '/gkzsb/school/'
            }else if (item.categroyName=='成教院校'){
              name = '/ckzsb/school/'
            }else if (item.categroyName=='自考院校'){
              name = '/zkzsb/school/'
            }
            window.open(
              data.AdminCache.sitePcWebUrl + name + item.id + ".html"
            );
          }
        }).catch((action) => {
          if(action === "cancel"){
            let name = ''
            if (item.categroyName=='开放教育'){
              name = '/gkzsb/school/'
            }else if (item.categroyName=='成教院校'){
              name = '/ckzsb/school/'
            }else if (item.categroyName=='自考院校'){
              name = '/zkzsb/school/'
            }
            var url =
              data.AdminCache.siteMobileWebUrl + name + item.id + '.html';
            if (item.name && item.name != null && item.name != "") {
              data.UrlOpenFlag = true;
              data.selectTitle = "查看院校[" + item.name + "]详情";
              data.mobileUrl = url;
            }
          }
      });
    };
    //获取列表
    function getSchoolData() {
      data.loading = true;
      const obj = {
        name: data.search.name,
        category: data.search.category,
        pageSize: data.pagination.pageSize,
        pageNumber: data.pagination.currentPage,
      };
      getSchoolList(obj)
          .then((result) => {
            if (result && result.code == 1) {
              const list = result.data;
              data.pagination.total = result.totalCount;
              data.tableData = list;
              data.loading = false;
            } else {
              data.loading = false;
              ElMessage.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    }

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.search.name = val.value;
      }
      if (val.prop && val.prop == "categroyName") {
        data.search.category = val.value;
      }
      data.pagination.currentPage = 1;
      getSchoolData();
    };

    //更新列表
    const updateList = () => {
      getSchoolData();
    };
    // 添加院校
    const addFnc = (e) => {
      // 强制去掉按钮focus
      lostFocus(e);
      data.addEditVisible = true;
      data.dialogTitle = "添加院校";
      data.editId = 0;
    };

    // 编辑院校
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${obj.name}】院校`;
      data.editId = obj.id;
    };

    // 删除
    const deleteFnc = (obj) => {
           ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${obj.name}`
          ),
          h("span", null, "】院校？ "),
        ]),
        showCancelButton: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            removeSchool(obj.id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
      .catch(() => {
        ElMessage("取消删除");
      });
    };

    function deleteData(id) {
      removeSchool(id)
          .then((result) => {
            if (result && result.code == 1) {
              ElMessage.success(result.message);
              updateList();
            } else {
              ElMessage.error(result.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
    }

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
      data.notpbMajorTable = false;
    };

    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

    //打开院校内容弹窗
    const openContent = (val) => {
      if (val.prop == "contents") {
        data.contentdialogTitle = `查看【${val.value.name}】院校内容`;
        data.contentVisible = true;
        data.contentDetails = val.value.contents;
      }
    };

    //设置关联专业
    const openReleve = (row) => {
      data.notpbMajorTable = true;
      data.majorIds = row.majors;
      data.schoolId = row.id;
      data.category = row.category

    };

    //关闭添加编辑弹窗操作
    const AddEditComponent = ref();
    const handleClose = () => {
      if (data.addEditVisible) {
        AddEditComponent.value.resetForm();
        data.addEditVisible = false;
      }
    };

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      updateList,
      closeDialog,
      changePagination,
      searchFnc,
      addFnc,
      editFnc,
      deleteFnc,
      openContent,
      openReleve,
      AddEditComponent,
      handleClose,
      openCourseDetail,
      UrlOpen,
    };
  },
};
</script>
<style scoped>

</style>

